import update from 'immutability-helper';

import * as AppConst from '../constants/App';
import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    youWillAlsoLike: [],
    isShowOriginal: false,
    calculationResult: {},
    isNeedCalculate: false,
    isShowCalendarLoading: true,
    isShowCalculationResult: false,
    isShowBackgroundLoading: false,
    currentObject: {
        props: {},
        description: {},
        price: {},
        location: {},
        meta: {
            images: [],
            userRepresent: {}
        }
    },
    bookingRequestParams: {
        countGuests: 0
    },
    calendars: {
        days: []
    }
});

export default (state = initialState(), action) => {
    let bookingRequestParams;
    let isNeedCalculate = false;

    switch (action.type) {
        case ActionTypes.GET_OBJECT_BY_ID:
            return {...state, currentObject: action.payload};
        case ActionTypes.SET_YOU_WILL_ALSO_LIKE:
            return {...state, youWillAlsoLike: action.payload};
        case ActionTypes.SET_DATE_START_OBJECT:
            let dateStartMoment = action.payload;
            if (dateStartMoment !== undefined) {
                bookingRequestParams = update(state.bookingRequestParams, {
                    dateStart: {$set: dateStartMoment.format(AppConst.DATE_FORMAT)}
                });
                if (bookingRequestParams.dateEnd !== undefined && bookingRequestParams.countGuests !== 0) {
                    isNeedCalculate = true;
                }
            } else {
                bookingRequestParams = update(state.bookingRequestParams, {
                    dateStart: {$set: undefined}
                });
            }
            return {
                ...state,
                dateStartMoment: dateStartMoment,
                isNeedCalculate: isNeedCalculate,
                bookingRequestParams: bookingRequestParams
            };
        case ActionTypes.SET_DATE_END_OBJECT:
            let dateEndMoment = action.payload;
            if (dateEndMoment !== undefined) {
                bookingRequestParams = update(state.bookingRequestParams, {
                    dateEnd: {$set: dateEndMoment.format(AppConst.DATE_FORMAT)}
                });
                if (bookingRequestParams.dateStart !== undefined && bookingRequestParams.countGuests !== 0) {
                    isNeedCalculate = true;
                }
            } else {
                bookingRequestParams = update(state.bookingRequestParams, {
                    dateEnd: {$set: undefined}
                });
            }
            return {
                ...state,
                dateEndMoment: dateEndMoment,
                isNeedCalculate: isNeedCalculate,
                bookingRequestParams: bookingRequestParams
            };
        case ActionTypes.BOOKING_CALCULATE:
            const isShowCalculationResult = action.payload.errorMessage === null;

            return {...state, isShowCalculationResult: isShowCalculationResult, calculationResult: action.payload};
        case ActionTypes.GET_CALENDARS:
            return {...state, calendars: action.payload, isShowCalendarLoading: false};
        case ActionTypes.SET_SHOW_ORIGINAL:
            return {...state, isShowOriginal: action.payload};
        case ActionTypes.SET_IS_SHOW_CALENDAR_LOADING:
            return {...state, isShowCalendarLoading: action.payload};
        case ActionTypes.ADD_CALENDARS:
            const func = days => days.concat(action.payload.days);
            let calendars = update(state.calendars, {
                days: {$apply: func},
                end: {$set: action.payload.end}
            });
            return {...state, calendars: calendars, isShowCalendarLoading: false};
        case ActionTypes.PROPERTY_CHANGE_BACKGROUND_LOADING:
            return {...state, isShowBackgroundLoading: action.payload};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ObjectPage.js